import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { ADMIN_NAV } from "./_nav";
import { api, errFrom, absUrl } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { FileText, Upload, ShieldCheck } from "lucide-react";

export default function AdminSops() {
  const [data, setData] = useState({ sops: [], policy: null });
  const [uploading, setUploading] = useState(null);

  async function load() {
    try { const { data: d } = await api.get("/admin/sops"); setData(d); }
    catch (e) { toast.error(errFrom(e)); }
  }
  useEffect(() => { load(); }, []);

  async function replaceSop(code, title, order, file) {
    if (!file) return;
    setUploading(code);
    try {
      const fd = new FormData();
      fd.append("code", code); fd.append("title", title); fd.append("order", order); fd.append("file", file);
      await api.post("/admin/sops", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("SOP replaced"); load();
    } catch (e) { toast.error(errFrom(e)); } finally { setUploading(null); }
  }

  async function replacePolicy(file) {
    if (!file) return;
    setUploading("policy");
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post("/admin/policy", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Policy replaced"); load();
    } catch (e) { toast.error(errFrom(e)); } finally { setUploading(null); }
  }

  return (
    <AppShell nav={ADMIN_NAV} title="SOPs & Policy" subtitle="Document library">
      <div className="brand-surface rounded-2xl p-6 mb-6" data-testid="policy-card">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-lg bg-[#FF3B30]/15 text-[#FF3B30] flex items-center justify-center"><ShieldCheck size={20} /></div>
          <div className="flex-1">
            <h2 className="font-heading font-bold text-xl">Onboarding Policy</h2>
            <p className="text-xs text-zinc-500 mt-1">Employees must sign this as part of onboarding.</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {data.policy?.url && <a href={absUrl(data.policy.url)} target="_blank" rel="noopener noreferrer" className="text-sm text-[#FF3B30] hover:underline">Open current policy</a>}
              <label className="ml-auto">
                <input type="file" accept="application/pdf" className="hidden" onChange={(e) => replacePolicy(e.target.files?.[0])} data-testid="replace-policy-input" />
                <span className="inline-flex items-center gap-1.5 bg-[#1C1C1E] border border-white/10 rounded-lg px-3 py-2 text-xs cursor-pointer hover:bg-[#2C2C2E]"><Upload size={12} />{uploading === "policy" ? "Uploading…" : "Replace"}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {data.sops.map((s) => (
          <div key={s.code} className="brand-surface rounded-2xl p-6 hover-lift" data-testid={`sop-card-${s.code}`}>
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#FF3B30]/15 text-[#FF3B30] flex items-center justify-center"><FileText size={20} /></div>
              <div className="flex-1">
                <div className="text-overline">Order {s.order}</div>
                <h3 className="font-heading font-bold text-lg mt-1">{s.title}</h3>
                <div className="mt-3 flex flex-wrap gap-2">
                  {s.url && <a href={absUrl(s.url)} target="_blank" rel="noopener noreferrer" className="text-sm text-[#FF3B30] hover:underline">Open PDF</a>}
                  <label className="ml-auto">
                    <input type="file" accept="application/pdf" className="hidden" onChange={(e) => replaceSop(s.code, s.title, s.order, e.target.files?.[0])} data-testid={`replace-sop-${s.code}`} />
                    <span className="inline-flex items-center gap-1.5 bg-[#1C1C1E] border border-white/10 rounded-lg px-3 py-2 text-xs cursor-pointer hover:bg-[#2C2C2E]"><Upload size={12} />{uploading === s.code ? "Uploading…" : "Replace"}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
